module.exports = __webpack_public_path__ + "static/ARUP-99743da6cc09285dbfc8b7db7645cdfe.png";